import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { BlockWordCloudComponent } from './block-wordCloud.component';
import { WordCloudModule } from '@app/components/wordCloud/wordCloud.module';

@NgModule({
  imports: [CommonModule, SharedModule, WordCloudModule],
  declarations: [BlockWordCloudComponent],
  exports: [BlockWordCloudComponent],
})
export class BlockWordCloudModule {}
